/**
 * Дедлайн валидности оффера.
 *
 * Принцип: у любого оффера на сайте/в гайде/в посте всегда есть явный
 * срок валидности (urgency для конверсии + защита от того что условия
 * «повиснут навсегда»).
 *
 * Формула: «конец календарного месяца, следующего за текущим».
 * Примеры (день вычисления → возвращаемая дата):
 *   12 мая  → 30 июня
 *   1 июня  → 31 июля
 *   31 дек  → 31 января следующего года
 *
 * SSG: дата фиксируется при build. Чтобы дедлайн оставался актуальным
 * без правок кода — GitHub Action `.github/workflows/weekly-rebuild.yml`
 * раз в неделю делает пустой коммит → Cloudflare Pages пересобирает
 * сайт → дата обновляется автоматически.
 */
export function getOfferDeadline(now: Date = new Date()): {
  iso: string
  human: string
  shortHuman: string
  humanEn: string
} {
  // new Date(year, month + 2, 0) → день 0 месяца (month+2) = последний день месяца (month+1).
  const end = new Date(now.getFullYear(), now.getMonth() + 2, 0)
  // Ручное форматирование без `г.` в конце (Intl.DateTimeFormat ru-RU
  // добавляет суффикс, который ломает читаемость в коротких фразах
  // вроде «до 30 июня 2026»).
  const MONTHS = [
    'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
    'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
  ]
  const MONTHS_EN = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ]
  const human = `${end.getDate()} ${MONTHS[end.getMonth()]} ${end.getFullYear()}`
  const shortHuman = `${end.getDate()} ${MONTHS[end.getMonth()]}`
  const humanEn = `${MONTHS_EN[end.getMonth()]} ${end.getDate()}, ${end.getFullYear()}`
  // ISO собираем из локальных компонент, не через toISOString() — иначе
  // на серверах с другим offset последний день месяца может «съехать»
  // на день назад (UTC < local).
  const iso = `${end.getFullYear()}-${String(end.getMonth() + 1).padStart(2, '0')}-${String(end.getDate()).padStart(2, '0')}`
  return {
    iso,
    human,
    shortHuman,
    humanEn,
  }
}
